/* Tiny env-gated logger: debug/info/warn are silenced in production builds, errors always surface. */
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => console.error(...args),
};
